import { pluralize, camelize } from "../helpers";
import ResponseStore from "../stores/ResponseStore";

export default class {
  constructor (resourceName) {
    this.resourceName = resourceName;
    this.collectionName = pluralize(resourceName);

    this.resourceNameCamelized = camelize(this.resourceName);
    this.collectionNameCamelized = camelize(this.collectionName);

    this.state = {};

    this.state[this.resourceNameCamelized] = {};
    this.state[this.collectionNameCamelized] = [];

    this.state.httpStatus = 200;
  }

  async fetchAll (params = {}) {
    const response = await fetch(
      `${this._baseUrl(params)}/${this.collectionName}`
    );

    return this._handleResponse(response);
  }

  async fetch (id, params = {}) {
    if (!this.state[this.resourceNameCamelized] ||
      this.state[this.resourceNameCamelized].id !== parseInt(id)) {
      const response = await fetch(this._resourceUrl(id, params));
      return this._handleResponse(response);
    } else {
      return {
        status: 200,
        success: true,
        resource: this.state[this.resourceNameCamelized]
      };
    }
  }

  async create (params = {}) {
    const response = await fetch(
      `${this._baseUrl(params)}/${this.collectionName}`, {
        body: new FormData(document.getElementById("form-card")),
        method: "POST"
      });

    return this._handleResponse(response);
  }

  async update (id, params = {}) {
    const response = await fetch(
      this._resourceUrl(id, params), {
        body: new FormData(document.getElementById("form-card")),
        method: "PUT"
      });

    return this._handleResponse(response);
  }

  async delete (id, params = {}) {
    const response = await fetch(
      this._resourceUrl(id, params),
      {
        method: "DELETE"
      }
    );

    return this._handleResponse(response);
  }

  async cancel (id, params = {}) {
    const response = await fetch(
      `${this._resourceUrl(id, params)}/cancel`, {
        method: "GET"
      });

    return this._handleResponse(response);
  }

  async collection (name, params = {}) {
    const response = await fetch(
      `${this._baseUrl(params)}/${this.collectionName}/${name}`
    );

    this.state.httpStatus = response.status;

    if (response.status === 200) {
      const responseJSON = await response.json();

      this.state[name] = responseJSON[this.collectionName];

      return this.state[name];
    }
  }

  async filter (filterKey, params = {}) {
    const response = await fetch(
      `${this._baseUrl(params)}/${this.collectionName}/filter?scope=${filterKey}`
    );

    return this._handleResponse(response);
  }

  _baseUrl (params) {
    throw new Error("Not Implemented");
  }

  _resourceUrl (id, params) {
    return `${this._baseUrl(params)}/${this._resourcePath(id)}`;
  }

  _resourcePath (id = null) {
    return `${this.collectionName}/${id}`;
  }

  async _handleResponse (response) {
    let result = {
      status: null,
      resource: {},
      collection: []
    };

    result.status = response.status;

    try {
      const responseJSON = await response.json();

      result.success = result.status === 200 && responseJSON.success;
      result.successMessage = responseJSON.successMessage;
      result.errorMessages = responseJSON.errorMessages;

      if (result.status !== 200) {
        result.errorMessages.push(`Error: ${result.status}`);
      }

      result.resource = responseJSON[this.resourceName];
      result.collection = responseJSON[this.collectionName];
      Object.assign(this.state[this.resourceNameCamelized], result.resource);
    } catch (err) {
      appsignal.sendError(err);
      result.success = false;
      result.errorMessages = [`Error: ${result.status}`];
    }

    ResponseStore.finishProcessing();

    return result;
  }
}
